var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "save_alt_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.048,
    height: 25.048,
    viewBox: "0 0 25.048 25.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16655",
    "data-name": "Path 16655",
    d: "M0,0H25.048V25.048H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16656",
    "data-name": "Path 16656",
    d: "M19.7,12.393V19.7H5.087V12.393H3V19.7a2.093,2.093,0,0,0,2.087,2.087H19.7A2.093,2.093,0,0,0,21.786,19.7V12.393Zm-6.262.7,2.7-2.693,1.472,1.472L12.393,17.09,7.175,11.871,8.646,10.4l2.7,2.693V3h2.087Z",
    transform: "translate(0.131 0.131)",
    fill: "#0074b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconBlue);
export default __webpack_public_path__ + "static/media/downloadIcon-blue.1a976bd92dfb43251d07dba9ff75ba27.svg";
export { ForwardRef as ReactComponent };